import React from 'react'
import styled from '@emotion/styled'
import { toTitleCase } from '@mobi/utils/string'
import type { Race } from '@mobi/betslip/types'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const RacingTitle: React.FC<{
  races: Pick<Race, 'raceNumber'>[]
  meetingName: string
  isMultipleRaceSelection: boolean
}> = ({ races, meetingName, isMultipleRaceSelection }) => {
  const racesToRender = isMultipleRaceSelection ? races : races.slice(0, 1)

  return (
    <span data-testid='RacingTitle'>
      {racesToRender.map(({ raceNumber }) => (
        <React.Fragment key={raceNumber}>
          <StatusBadgeStyled>R{raceNumber}</StatusBadgeStyled>{' '}
        </React.Fragment>
      ))}{' '}
      {toTitleCase(meetingName)}
    </span>
  )
}

// ======
// Styles
// ======

const StatusBadgeStyled = styled.span({
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: spacing.smx2,
  padding: spacing.smx2,
  borderRadius: radius.smx1,
  color: colors.neutral[900],
  backgroundColor: colors.neutral[100],
  fontFamily: font.family.primary,
  fontSize: font.size.sm.fontSize,
  lineHeight: font.size.sm.lineHeight,
  letterSpacing: font.size.sm.letterSpacing,
  fontWeight: font.weight.regular,
})
